import { is } from '../../is.js';
import { getStyleDeclaration } from './get-style-declaration.js';
import {
  activeState,
  getOutlineDeclaration,
  hoverState,
  outliner,
  widgetSelector,
} from './helpers';
import { px2em } from '#/providers/creative/px2em/@impl/px2em.js';

/**
 * Transform image widget description into list of style declarations.
 * 1. Кликабельность
 * 2. координаты / width / height
 * 3. border radius
 * 4. угол поворота
 * 5. cdn link
 *
 * настройки для разных состояний для каждой из платформ:
 *
 * 6. opacity
 *
 * настройки кликабельных  изображений
 * 7. Stroke: ширина линии / color / opacity
 * 8. Scale
 * 9. internal link
 * @example
 * {
 *   "id": "imageWidget_231638",
 *   "type": "image",
 *   "x": 81,
 *   "y": 398,
 *   "width": 407,
 *   "height": 237,
 *   "rotationAngle": 0,
 *   "url": "http://s7.vcdn.biz/static/f/4946782641/Знімокекраназ2022-08-1010-42-33.png",
 *   "linkType": "megogo://main",
 *   "isMainTarget": false,
 *   "isClickable": false,
 *   "styledStates": {
 *     "default": {
 *       "scale": 1,
 *       "opacity": 1,
 *       "borderSize": 0,
 *       "borderColor": "rgba(255, 255, 255, 1)",
 *       "borderRadius": 0,
 *       "borderGap": 0,
 *     },
 *     "hover": {
 *       "scale": 1,
 *       "opacity": 1,
 *       "borderSize": 0,
 *       "borderColor": "rgba(255, 255, 255, 1)",
 *       "borderRadius": 0,
 *       "borderGap": 0,
 *     },
 *     "click": {
 *       "scale": 1,
 *       "opacity": 1,
 *       "borderSize": 0,
 *       "borderColor": "rgba(255, 255, 255, 1)",
 *       "borderRadius": 0
 *       "borderGap": 0,
 *     }
 *   },
 *   "_name": "Знімок екрана з 2022-08-10 10-42-33.png",
 *   "_isModified": false
 * }
 * @param widgetDescription
 */
export function imageWidget(widgetDescription) {
  const { rotationAngle, styledStates, placements, isClickable } =
    widgetDescription;
  const selector = widgetSelector(widgetDescription);

  if (
    is.widget.voteButton(widgetDescription.parent) ||
    is.widget.quizButton(widgetDescription.parent)
  ) {
    /*
    image widget used as poll option's child does not have nor own styled states,
     nor placements and should rely on styles defined via classes
    */
    return [];
  }

  const { default: base, hover, click: active } = styledStates;

  const rules = [
    ...placements.map(getStyleDeclaration.positions(selector)),
    ...placements.map(getStyleDeclaration.size(selector)),
  ];

  rules.push([
    selector,
    [
      ['transform', `rotateZ(${rotationAngle}deg) scale(${base.scale})`],
      ['opacity', base.opacity],
      ['border-radius', px2em(base.borderRadius)],
    ],
  ]);

  rules.push([outliner(selector), getOutlineDeclaration(base)]);

  if (isClickable) {
    rules.push([
      hoverState(selector),
      [
        ['transform', `rotateZ(${rotationAngle}deg) scale(${hover.scale})`],
        ['opacity', hover.opacity],
        ['border-radius', px2em(hover.borderRadius)],
      ],
    ]);
    rules.push([
      activeState(selector),
      [
        ['transform', `rotateZ(${rotationAngle}deg) scale(${active.scale})`],
        ['opacity', active.opacity],
        ['border-radius', px2em(active.borderRadius)],
      ],
    ]);

    rules.push([
      hoverState(selector).map(outliner),
      getOutlineDeclaration(hover),
    ]);

    rules.push([
      activeState(selector).map(outliner),
      getOutlineDeclaration(active),
    ]);
  }

  return rules;
}
